import { apiCall, filterParams } from '../helpers/axios';

class BidNumberService {

	static getByPersonId(personId, params) {
		return apiCall().get(`/persons/${personId}/bid_numbers`, { params: params })
			.then(response => response.data);
	}

	static getByBidNumber(bidNumber, params) {
		return apiCall().get(`/bid_numbers/${bidNumber}`, { params: params })
			.then(response => response.data);
	}

	static create(bidNumber) {
		return apiCall().post(`/bid_numbers`, bidNumber)
			.then(response => response.data);
	}

	static delete(bidNumberId) {
		return apiCall().delete(`/bid_numbers/${bidNumberId}`)
			.then(response => response.data);
	}

	static getBidNumberCost(auctionId, bidNumber) {
		return apiCall().get(`/auctions/${auctionId}/bid_number/${bidNumber}/costs`)
			.then(response => response.data);
	}

	static updateBidNumberCost(auctionId, bidNumber, data) {
		return apiCall().put(`/auctions/${auctionId}/bid_number/${bidNumber}/costs`, data)
			.then(response => response.data);
	}

	static getPersonBidNumbers(auctionId, params) {
		return apiCall().get(`/auctions/${auctionId}/person_bid_numbers`, { params: params })
			.then(response => response.data);
	}
}

export default BidNumberService


// WEBPACK FOOTER //
// ./src/services/bid-number-service.js